import { BaseHealthCardParser } from "./BaseHealthCardParser";

export class BritishColumbiaCardParser extends BaseHealthCardParser {
    private OneDimensionRegex = /^\d{10}$/;
    private TwoDimensionRegex = [
        /^(%BC)(?<City>([^^?]{13})|([^^?]{0,12}\^))(?<Name>([^^?]{35})|([^^?]{0,34}\^))(?<Address>[^^?]*)\??.*(;636028)(?<CardNumber>[^=]{0,13})=(?<CardExpiry>\d{4})(?<BirthDate>\d{8})=.*_%\dA(?<PostalCode>(.|\s){11})(\s{16})(?<Sex>M|F|X)(?<Height>(\d|\s){3})(?<Weight>(\d|\s){3})(?<HairColor>(.|\s){3})(?<EyeColor>(.|\s){3})(?<HealthCareNumber>\d{10}).*?/,
        /^(%BC)(?<City>([^^?]{13})|([^^?]{0,12}\?))(?<Name>([^^?]{35})|([^^?]{0,34}\?))(?<Address>[^^?]*)\??.*(;636028)(?<CardNumber>[^=]{0,13})=(?<CardExpiry>\d{4})(?<BirthDate>\d{8})=.*_%\dA(?<PostalCode>(.|\s){11})(\s{16})(?<Sex>M|F|X)(?<Height>(\d|\s){3})(?<Weight>(\d|\s){3})(?<HairColor>(.|\s){3})(?<EyeColor>(.|\s){3})(?<HealthCareNumber>\d{10}).*?/
    ];

    protected GetOneDimensionRegex(): RegExp {
        return this.OneDimensionRegex;
    }

    protected GetTwoDimensionRegex(): RegExp[] {
        return this.TwoDimensionRegex;
    }
}



// WEBPACK FOOTER //
// ./src/services/HealthCardBarcodeScanParsers/BritishColumbiaCardParser.ts